<script>
import { BNavbarToggle } from "bootstrap-vue";

export default {
  extends: BNavbarToggle
};
</script>